import NATIVE_PARITY_COPY from "./public-web-native-parity-copy.json";
import AUTH_COPY from "./public-web-auth-copy.json";
import AUDIO_FEEDBACK_COPY from "./public-web-audio-feedback-copy.json";
import CALENDAR_COPY from "./public-web-calendar-copy.json";
import CHROME_COPY from "./public-web-chrome-copy.json";
import BRIEF_CONTENT_COPY from "./public-web-brief-content-copy.json";
import BRIEF_CORE_COPY from "./public-web-brief-core-copy.json";
import BRIEF_TUNE_COPY from "./public-web-brief-tune-copy.json";
import HOME_CAROUSEL_COPY from "./public-web-home-carousel-copy.json";
import HOME_COPY from "./public-web-home-copy.json";
import LIBRARY_COPY from "./public-web-library-copy.json";
import FOUNDATION_COPY from "./public-web-foundation-overrides.json";
import ONBOARDING_COPY from "./public-web-onboarding-overrides.json";
import MARKETING_SHELL_COPY from "./public-web-marketing-shell-overrides.json";
import PREAUTH_AUTH_CHROME_COPY from "./public-web-preauth-auth-chrome-overrides.json";
import SETTINGS_FOUNDATION_COPY from "./public-web-settings-foundation-overrides.json";
import MARKETING_MAIN_COPY from "./public-web-marketing-main-copy.json";
import MARKETING_PAGES_COPY from "./public-web-marketing-pages-copy.json";
import SETTINGS_COPY from "./public-web-settings-copy.json";
import SETTINGS_PROFILE_COPY from "./public-web-settings-profile-copy.json";
import SETTINGS_SURFACE_COPY from "./public-web-settings-surface-copy.json";
import { restoredProductLanguage } from "../onboarding/experience-catalog.mjs";

const EN_COPY = {
  "common.share": "Share",
  "common.viewPlans": "View plans",
  "common.tryAgain": "Try again",
  "common.refreshing": "Refreshing...",
  "common.remove": "Remove",
  "common.play": "Play",
  "common.stop": "Stop",
  "common.dismiss": "Dismiss",
  "common.loadingAudio": "Loading audio",
  "common.nowPlaying": "Now playing",
  "common.audio": "Audio",
  "audio.buffering": "Buffering",
  "audio.collapse": "Close expanded player",
  "audio.controls": "Playback controls",
  "audio.download": "Download MP3",
  "audio.expand": "Open full audio player",
  "audio.forward": "Skip forward 15 seconds",
  "audio.narrator": "Narrator",
  "audio.narratorFuture": "Applies to your next generated listen",
  "audio.pause": "Pause audio",
  "audio.paused": "Paused",
  "audio.playbackSpeed": "Playback speed",
  "audio.premiumListening": "Premium listening",
  "audio.resume": "Resume audio",
  "audio.rewind": "Go back 15 seconds",
  "audio.seek": "Audio position",
  "audio.stopClose": "Stop audio and close player",
  "brief.eyebrow": "Today's Brief",
  "brief.goodMorning": "Good morning",
  "brief.start": "Start brief",
  "brief.restart": "Restart",
  "brief.stopAudio": "Stop audio",
  "brief.loading": "Loading...",
  "brief.listenMinutes": "{minutes} min listen",
  "brief.addToQueue": "Add to queue",
  "brief.freeAudioNote": "Free daily listens are included. Premium or trial lifts the limits.",
  "brief.loadError": "We couldn't load your brief right now.",
  "brief.journey": "Brief journey",
  "brief.sectionsMeta": "{count} sections - {depth} - {country}",
  "brief.orderNote": "Default order starts with {order}.",
  "brief.sectionTabs": "Brief sections",
  "brief.previous": "Previous",
  "brief.next": "Next section",
  "brief.complete": "Complete brief",
  "brief.completed": "Brief completed. Your latest run was added to history.",
  "brief.shareIt": "Share it",
  "brief.tune": "Tune",
  "brief.depth": "Depth",
  "brief.depth.focused": "Focused",
  "brief.depth.balanced": "Balanced",
  "brief.depth.deep": "Deep",
  "brief.audioLength": "Audio length",
  "brief.minutes": "{minutes} minutes",
  "brief.includeTasks": "Include task context",
  "brief.includeMarkets": "Include market pulse",
  "brief.defaultOrderTitle": "{country} default order",
  "brief.runHistory": "Run history",
  "brief.historyEmpty": "Complete a brief to start your history.",
  "brief.historyLine": "{sections} sections - {minutes} min - {depth}",
  "brief.audioCompanion": "Audio companion",
  "brief.downloadCurrent": "Download current MP3",
  "brief.downloadUnavailable": "Start a generated listen to download the MP3 in this browser.",
  "brief.queueTitle": "Up next",
  "brief.queueEmpty": "Queue a listen before a walk, drive, or focus block.",
  "brief.recentListens": "Recent listens",
  "brief.audioHistoryEmpty": "Generated listens will appear here after playback starts.",
  "brief.queuedStatus": "Added to audio queue.",
  "brief.openSource": "Open source",
  "brief.shareText": "I just finished a {count}-section Today's Brief.",
  "brief.shareStatusLabel": "Brief link",
  "brief.categoryLabel": "Your brief",
  "brief.fallbackSummary": "Your personalized brief is ready.",
  "onboarding.title": "Set up Today's Brief",
  "onboarding.description": "Choose your region, language, and daily brief style.",
  "onboarding.eyebrow": "First brief setup",
  "onboarding.heading": "Make it yours.",
  "onboarding.body": "Your country. Your language.\nA daily Brief that feels like you.",
  "onboarding.edition": "Your edition",
  "onboarding.editionBody": "Country sets your default headlines and market watchlist.",
  "onboarding.language": "Language",
  "onboarding.languageBody": "Pick the app/news language to start with. You can change it later.",
  "onboarding.profile": "Brief profile",
  "onboarding.profileBody": "These help the brief address you and tune the starting depth.",
  "onboarding.displayName": "Display name",
  "onboarding.localCity": "Local city",
  "onboarding.optional": "Optional",
  "onboarding.briefDepth": "Brief depth",
  "onboarding.preparing": "Preparing...",
  "onboarding.prepare": "Prepare my brief",
  "onboarding.skip": "Skip to app",
  "onboarding.signIn": "I already have an account",
  "onboarding.preview": "Setup preview",
  "onboarding.previewEdition": "Edition",
  "onboarding.previewPace": "{language} brief - {depth} pace",
  "onboarding.firstPaint": "First paint",
  "onboarding.warming": "Warming content",
  "onboarding.ready": "Ready",
  "onboarding.warmSources": "News, quote, markets",
  "onboarding.localIncluded": "{city} local news included",
  "onboarding.addCity": "Add a city for local headlines.",
  "onboarding.indiaLocalSetup":
    "Choose a catalog city in Preferences after setup, or use device location on Android.",
  "onboarding.placesSetup":
    "Weather and commute locations are available in Preferences after setup.",
  "onboarding.openPreferences": "Open Preferences",
  "onboarding.briefOrder": "Brief order",
  "onboarding.countryDefault": "{country} default",
  "onboarding.next": "Next",
  "onboarding.saved": "Your setup is saved",
  "onboarding.createSync": "Create an account to keep this setup across web and Android.",
  "onboarding.createAccount": "Create account",
  "onboarding.openBrief": "Open your brief",
  "onboarding.createAccountPrompt": "Create your account",
  "onboarding.openWhenReady": "You can enter the app as soon as the warmup finishes.",
  "onboarding.accountKeepsPrefs":
    "Account creation keeps your preferences and starts the synced app flow.",
  "onboarding.openBriefButton": "Open brief",
  "layout.audioPlayer": "Audio player",
  "layout.theme": "Theme",
  "layout.signOut": "Sign out",
} as const;

type AuthCopyKey = keyof typeof AUTH_COPY.en;
type AudioFeedbackCopyKey = keyof typeof AUDIO_FEEDBACK_COPY.en;
type CalendarCopyKey = keyof typeof CALENDAR_COPY.en;
type ChromeCopyKey = keyof typeof CHROME_COPY.en;
type BriefContentCopyKey = keyof typeof BRIEF_CONTENT_COPY.en;
type BriefCoreCopyKey = keyof typeof BRIEF_CORE_COPY.en;
type BriefTuneCopyKey = keyof typeof BRIEF_TUNE_COPY.en;
type HomeCarouselCopyKey = keyof typeof HOME_CAROUSEL_COPY.en;
type HomeCopyKey = keyof typeof HOME_COPY.en;
type LibraryCopyKey = keyof typeof LIBRARY_COPY.en;
type MarketingMainCopyKey = keyof typeof MARKETING_MAIN_COPY.en;
type MarketingPagesCopyKey = keyof typeof MARKETING_PAGES_COPY.en;
type SettingsCopyKey = keyof typeof SETTINGS_COPY.en;
type SettingsProfileCopyKey = keyof typeof SETTINGS_PROFILE_COPY.en;
type SettingsSurfaceCopyKey = keyof typeof SETTINGS_SURFACE_COPY.en;

export type PublicWebCopyKey =
  | keyof typeof NATIVE_PARITY_COPY.en
  | keyof typeof EN_COPY
  | AuthCopyKey
  | AudioFeedbackCopyKey
  | CalendarCopyKey
  | ChromeCopyKey
  | BriefContentCopyKey
  | BriefCoreCopyKey
  | BriefTuneCopyKey
  | HomeCarouselCopyKey
  | HomeCopyKey
  | LibraryCopyKey
  | MarketingMainCopyKey
  | MarketingPagesCopyKey
  | SettingsCopyKey
  | SettingsProfileCopyKey
  | SettingsSurfaceCopyKey;

type CopyVars = Record<string, string | number | undefined | null>;
type CopyDictionary = Readonly<Record<PublicWebCopyKey, string>>;

const ENGLISH_COPY_DICTIONARY = {
  ...EN_COPY,
  ...AUTH_COPY.en,
  ...AUDIO_FEEDBACK_COPY.en,
  ...CALENDAR_COPY.en,
  ...CHROME_COPY.en,
  ...BRIEF_CONTENT_COPY.en,
  ...BRIEF_CORE_COPY.en,
  ...BRIEF_TUNE_COPY.en,
  ...HOME_CAROUSEL_COPY.en,
  ...HOME_COPY.en,
  ...LIBRARY_COPY.en,
  ...MARKETING_MAIN_COPY.en,
  ...MARKETING_PAGES_COPY.en,
  ...SETTINGS_COPY.en,
  ...SETTINGS_PROFILE_COPY.en,
  ...SETTINGS_SURFACE_COPY.en,
  ...NATIVE_PARITY_COPY.en,
} satisfies CopyDictionary;

const COPY_BY_LANG: Record<string, CopyDictionary> = {
  en: ENGLISH_COPY_DICTIONARY,
  hi: {
    "common.share": "साझा करें",
    "common.viewPlans": "प्लान देखें",
    "common.tryAgain": "फिर कोशिश करें",
    "common.refreshing": "रीफ्रेश हो रहा है...",
    "common.remove": "हटाएं",
    "common.play": "चलाएं",
    "common.stop": "रोकें",
    "common.dismiss": "बंद करें",
    "common.loadingAudio": "ऑडियो लोड हो रहा है",
    "common.nowPlaying": "अभी चल रहा है",
    "common.audio": "ऑडियो",
    "audio.buffering": "बफ़र हो रहा है",
    "audio.collapse": "विस्तृत प्लेयर बंद करें",
    "audio.controls": "प्लेबैक नियंत्रण",
    "audio.download": "MP3 डाउनलोड करें",
    "audio.expand": "पूरा ऑडियो प्लेयर खोलें",
    "audio.forward": "15 सेकंड आगे जाएं",
    "audio.narrator": "वाचक",
    "audio.narratorFuture": "अगली जनरेट की गई सुनाई पर लागू होगा",
    "audio.pause": "ऑडियो पॉज़ करें",
    "audio.paused": "रुका हुआ",
    "audio.playbackSpeed": "प्लेबैक गति",
    "audio.premiumListening": "प्रीमियम लिसनिंग",
    "audio.resume": "ऑडियो फिर चलाएं",
    "audio.rewind": "15 सेकंड पीछे जाएं",
    "audio.seek": "ऑडियो स्थिति",
    "audio.stopClose": "ऑडियो रोककर प्लेयर बंद करें",
    "brief.eyebrow": "आज का ब्रीफ",
    "brief.goodMorning": "सुप्रभात",
    "brief.start": "ब्रीफ शुरू करें",
    "brief.restart": "फिर शुरू करें",
    "brief.stopAudio": "ऑडियो रोकें",
    "brief.loading": "लोड हो रहा है...",
    "brief.listenMinutes": "{minutes} मिनट सुनें",
    "brief.addToQueue": "कतार में जोड़ें",
    "brief.freeAudioNote": "मुफ्त दैनिक सुनना शामिल है. प्रीमियम या ट्रायल सीमा बढ़ाता है.",
    "brief.loadError": "आपका ब्रीफ अभी लोड नहीं हो सका.",
    "brief.journey": "ब्रीफ यात्रा",
    "brief.sectionsMeta": "{count} सेक्शन - {depth} - {country}",
    "brief.orderNote": "डिफॉल्ट क्रम {order} से शुरू होता है.",
    "brief.sectionTabs": "ब्रीफ सेक्शन",
    "brief.previous": "पिछला",
    "brief.next": "अगला सेक्शन",
    "brief.complete": "ब्रीफ पूरा करें",
    "brief.completed": "ब्रीफ पूरा हुआ. आपकी नई रन हिस्ट्री में जुड़ गई.",
    "brief.shareIt": "साझा करें",
    "brief.tune": "ट्यून करें",
    "brief.depth": "गहराई",
    "brief.depth.focused": "फोकस्ड",
    "brief.depth.balanced": "संतुलित",
    "brief.depth.deep": "डीप",
    "brief.audioLength": "ऑडियो लंबाई",
    "brief.minutes": "{minutes} मिनट",
    "brief.includeTasks": "टास्क संदर्भ शामिल करें",
    "brief.includeMarkets": "मार्केट पल्स शामिल करें",
    "brief.defaultOrderTitle": "{country} डिफॉल्ट क्रम",
    "brief.runHistory": "रन हिस्ट्री",
    "brief.historyEmpty": "हिस्ट्री शुरू करने के लिए एक ब्रीफ पूरा करें.",
    "brief.historyLine": "{sections} सेक्शन - {minutes} मिनट - {depth}",
    "brief.audioCompanion": "ऑडियो साथी",
    "brief.downloadCurrent": "वर्तमान MP3 डाउनलोड करें",
    "brief.downloadUnavailable":
      "इस ब्राउज़र में MP3 डाउनलोड करने के लिए एक जनरेटेड सुनना शुरू करें.",
    "brief.queueTitle": "अगला",
    "brief.queueEmpty": "वॉक, ड्राइव या फोकस ब्लॉक से पहले एक सुनना कतार में जोड़ें.",
    "brief.recentListens": "हाल की सुनाई",
    "brief.audioHistoryEmpty": "प्लेबैक शुरू होने के बाद जनरेटेड सुनाई यहां दिखेंगी.",
    "brief.queuedStatus": "ऑडियो कतार में जोड़ दिया गया.",
    "brief.openSource": "सोर्स खोलें",
    "brief.shareText": "मैंने अभी {count}-सेक्शन Today's Brief पूरा किया.",
    "brief.shareStatusLabel": "ब्रीफ लिंक",
    "brief.categoryLabel": "आपका ब्रीफ",
    "brief.fallbackSummary": "आपका निजी ब्रीफ तैयार है.",
    "onboarding.title": "Today's Brief सेट करें",
    "onboarding.description": "अपना क्षेत्र, भाषा और दैनिक ब्रीफ शैली चुनें.",
    "onboarding.eyebrow": "पहला ब्रीफ सेटअप",
    "onboarding.editionBody": "देश आपके डिफॉल्ट हेडलाइन और मार्केट वॉचलिस्ट सेट करता है.",
    "onboarding.language": "भाषा",
    "onboarding.languageBody": "शुरुआत के लिए ऐप/न्यूज़ भाषा चुनें. बाद में बदल सकते हैं.",
    "onboarding.profile": "ब्रीफ प्रोफाइल",
    "onboarding.profileBody": "ये ब्रीफ को आपका नाम और सही गहराई देने में मदद करते हैं.",
    "onboarding.displayName": "डिस्प्ले नाम",
    "onboarding.localCity": "स्थानीय शहर",
    "onboarding.optional": "वैकल्पिक",
    "onboarding.briefDepth": "ब्रीफ गहराई",
    "onboarding.preparing": "तैयार हो रहा है...",
    "onboarding.prepare": "मेरा ब्रीफ तैयार करें",
    "onboarding.skip": "ऐप पर जाएं",
    "onboarding.signIn": "मेरा पहले से खाता है",
    "onboarding.preview": "सेटअप प्रीव्यू",
    "onboarding.previewEdition": "संस्करण",
    "onboarding.previewPace": "{language} ब्रीफ - {depth} गति",
    "onboarding.firstPaint": "पहली झलक",
    "onboarding.warming": "कंटेंट तैयार हो रहा है",
    "onboarding.ready": "तैयार",
    "onboarding.warmSources": "समाचार, कोट, बाज़ार",
    "onboarding.localIncluded": "{city} स्थानीय समाचार शामिल",
    "onboarding.addCity": "स्थानीय हेडलाइन के लिए शहर जोड़ें.",
    "onboarding.indiaLocalSetup":
      "सेटअप के बाद प्राथमिकताओं में कैटलॉग शहर चुनें, या Android पर डिवाइस लोकेशन का उपयोग करें.",
    "onboarding.placesSetup": "सेटअप के बाद प्राथमिकताओं में मौसम और आवागमन के स्थान उपलब्ध हैं.",
    "onboarding.openPreferences": "प्राथमिकताएं खोलें",
    "onboarding.briefOrder": "ब्रीफ क्रम",
    "onboarding.countryDefault": "{country} डिफॉल्ट",
    "onboarding.next": "अगला",
    "onboarding.saved": "आपका सेटअप सेव हो गया",
    "onboarding.createSync": "वेब और Android पर यह सेटअप रखने के लिए खाता बनाएं.",
    "onboarding.createAccount": "खाता बनाएं",
    "onboarding.openBrief": "अपना ब्रीफ खोलें",
    "onboarding.createAccountPrompt": "अपना खाता बनाएं",
    "onboarding.openWhenReady": "वार्मअप खत्म होते ही आप ऐप खोल सकते हैं.",
    "onboarding.accountKeepsPrefs": "खाता बनाने से आपकी पसंद सेव रहती है और सिंक शुरू होता है.",
    "onboarding.openBriefButton": "ब्रीफ खोलें",
    "layout.audioPlayer": "ऑडियो प्लेयर",
    "layout.theme": "थीम",
    "layout.signOut": "साइन आउट",
    ...AUTH_COPY.hi,
    ...AUDIO_FEEDBACK_COPY.hi,
    ...CALENDAR_COPY.hi,
    ...CHROME_COPY.hi,
    ...BRIEF_CONTENT_COPY.hi,
    ...BRIEF_CORE_COPY.hi,
    ...BRIEF_TUNE_COPY.hi,
    ...HOME_CAROUSEL_COPY.hi,
    ...HOME_COPY.hi,
    ...LIBRARY_COPY.hi,
    ...MARKETING_MAIN_COPY.hi,
    ...MARKETING_PAGES_COPY.hi,
    ...SETTINGS_COPY.hi,
    ...SETTINGS_PROFILE_COPY.hi,
    ...SETTINGS_SURFACE_COPY.hi,
    ...NATIVE_PARITY_COPY.hi,
    "onboarding.heading": "अपने हिसाब से चुनें।",
    "onboarding.body": "आपका देश। आपकी भाषा।\nआपके लिए बना रोज़ का ब्रीफ़।",
    "onboarding.edition": "आपका संस्करण",
  },
  gu: {
    "common.share": "શેર કરો",
    "common.viewPlans": "પ્લાન જુઓ",
    "common.tryAgain": "ફરી પ્રયાસ કરો",
    "common.refreshing": "રીફ્રેશ થઈ રહ્યું છે...",
    "common.remove": "દૂર કરો",
    "common.play": "ચલાવો",
    "common.stop": "રોકો",
    "common.dismiss": "બંધ કરો",
    "common.loadingAudio": "ઑડિયો લોડ થઈ રહ્યો છે",
    "common.nowPlaying": "હમણાં ચાલી રહ્યું છે",
    "common.audio": "ઑડિયો",
    "audio.buffering": "બફર થઈ રહ્યું છે",
    "audio.collapse": "વિસ્તૃત પ્લેયર બંધ કરો",
    "audio.controls": "પ્લેબેક નિયંત્રણો",
    "audio.download": "MP3 ડાઉનલોડ કરો",
    "audio.expand": "પૂર્ણ ઑડિયો પ્લેયર ખોલો",
    "audio.forward": "15 સેકન્ડ આગળ જાઓ",
    "audio.narrator": "વાચક",
    "audio.narratorFuture": "તમારા આગામી જનરેટ થયેલા સાંભળવા પર લાગુ થશે",
    "audio.pause": "ઑડિયો થોભાવો",
    "audio.paused": "થોભાવેલું",
    "audio.playbackSpeed": "પ્લેબેક ગતિ",
    "audio.premiumListening": "પ્રીમિયમ લિસનિંગ",
    "audio.resume": "ઑડિયો ફરી ચલાવો",
    "audio.rewind": "15 સેકન્ડ પાછળ જાઓ",
    "audio.seek": "ઑડિયો સ્થાન",
    "audio.stopClose": "ઑડિયો રોકીને પ્લેયર બંધ કરો",
    "brief.eyebrow": "આજનો બ્રીફ",
    "brief.goodMorning": "સુપ્રભાત",
    "brief.start": "બ્રીફ શરૂ કરો",
    "brief.restart": "ફરી શરૂ કરો",
    "brief.stopAudio": "ઑડિયો રોકો",
    "brief.loading": "લોડ થઈ રહ્યું છે...",
    "brief.listenMinutes": "{minutes} મિનિટ સાંભળો",
    "brief.addToQueue": "કતારમાં ઉમેરો",
    "brief.freeAudioNote": "મફત દૈનિક સાંભળવું સામેલ છે. પ્રીમિયમ અથવા ટ્રાયલ મર્યાદા વધારે છે.",
    "brief.loadError": "તમારો બ્રીફ અત્યારે લોડ થઈ શક્યો નથી.",
    "brief.journey": "બ્રીફ યાત્રા",
    "brief.sectionsMeta": "{count} વિભાગ - {depth} - {country}",
    "brief.orderNote": "ડિફૉલ્ટ ક્રમ {order} થી શરૂ થાય છે.",
    "brief.sectionTabs": "બ્રીફ વિભાગો",
    "brief.previous": "પાછળ",
    "brief.next": "આગળનો વિભાગ",
    "brief.complete": "બ્રીફ પૂર્ણ કરો",
    "brief.completed": "બ્રીફ પૂર્ણ થયો. તમારી નવી રન હિસ્ટરીમાં ઉમેરાઈ.",
    "brief.shareIt": "શેર કરો",
    "brief.tune": "ટ્યુન કરો",
    "brief.depth": "ઊંડાણ",
    "brief.depth.focused": "ફોકસ્ડ",
    "brief.depth.balanced": "સંતુલિત",
    "brief.depth.deep": "ડીપ",
    "brief.audioLength": "ઑડિયો લંબાઈ",
    "brief.minutes": "{minutes} મિનિટ",
    "brief.includeTasks": "ટાસ્ક સંદર્ભ ઉમેરો",
    "brief.includeMarkets": "માર્કેટ પલ્સ ઉમેરો",
    "brief.defaultOrderTitle": "{country} ડિફૉલ્ટ ક્રમ",
    "brief.runHistory": "રન હિસ્ટરી",
    "brief.historyEmpty": "હિસ્ટરી શરૂ કરવા માટે બ્રીફ પૂર્ણ કરો.",
    "brief.historyLine": "{sections} વિભાગ - {minutes} મિનિટ - {depth}",
    "brief.audioCompanion": "ઑડિયો સાથી",
    "brief.downloadCurrent": "વર્તમાન MP3 ડાઉનલોડ કરો",
    "brief.downloadUnavailable":
      "આ બ્રાઉઝરમાં MP3 ડાઉનલોડ કરવા માટે જનરેટ થયેલું સાંભળવું શરૂ કરો.",
    "brief.queueTitle": "આગળ",
    "brief.queueEmpty": "વૉક, ડ્રાઇવ અથવા ફોકસ બ્લોક પહેલાં સાંભળવું કતારમાં ઉમેરો.",
    "brief.recentListens": "તાજેતરના સાંભળેલા",
    "brief.audioHistoryEmpty": "પ્લેબેક શરૂ થયા પછી જનરેટેડ સાંભળેલા અહીં દેખાશે.",
    "brief.queuedStatus": "ઑડિયો કતારમાં ઉમેરાયું.",
    "brief.openSource": "સોર્સ ખોલો",
    "brief.shareText": "મેં હમણાં {count}-વિભાગ Today's Brief પૂર્ણ કર્યો.",
    "brief.shareStatusLabel": "બ્રીફ લિંક",
    "brief.categoryLabel": "તમારો બ્રીફ",
    "brief.fallbackSummary": "તમારો વ્યક્તિગત બ્રીફ તૈયાર છે.",
    "onboarding.title": "Today's Brief સેટ કરો",
    "onboarding.description": "તમારો પ્રદેશ, ભાષા અને દૈનિક બ્રીફ શૈલી પસંદ કરો.",
    "onboarding.eyebrow": "પ્રથમ બ્રીફ સેટઅપ",
    "onboarding.editionBody": "દેશ તમારા ડિફૉલ્ટ હેડલાઇન્સ અને માર્કેટ વૉચલિસ્ટ સેટ કરે છે.",
    "onboarding.language": "ભાષા",
    "onboarding.languageBody": "શરૂઆત માટે એપ/ન્યૂઝ ભાષા પસંદ કરો. પછી બદલી શકો છો.",
    "onboarding.profile": "બ્રીફ પ્રોફાઇલ",
    "onboarding.profileBody": "આ બ્રીફને તમારું નામ અને યોગ્ય ઊંડાણ આપવા મદદ કરે છે.",
    "onboarding.displayName": "ડિસ્પ્લે નામ",
    "onboarding.localCity": "સ્થાનિક શહેર",
    "onboarding.optional": "વૈકલ્પિક",
    "onboarding.briefDepth": "બ્રીફ ઊંડાણ",
    "onboarding.preparing": "તૈયાર થઈ રહ્યું છે...",
    "onboarding.prepare": "મારો બ્રીફ તૈયાર કરો",
    "onboarding.skip": "એપ પર જાઓ",
    "onboarding.signIn": "મારું પહેલેથી ખાતું છે",
    "onboarding.preview": "સેટઅપ પૂર્વાવલોકન",
    "onboarding.previewEdition": "એડિશન",
    "onboarding.previewPace": "{language} બ્રીફ - {depth} ગતિ",
    "onboarding.firstPaint": "પ્રથમ ઝલક",
    "onboarding.warming": "સામગ્રી તૈયાર થઈ રહી છે",
    "onboarding.ready": "તૈયાર",
    "onboarding.warmSources": "સમાચાર, કોટ, બજારો",
    "onboarding.localIncluded": "{city} સ્થાનિક સમાચાર સામેલ",
    "onboarding.addCity": "સ્થાનિક હેડલાઇન્સ માટે શહેર ઉમેરો.",
    "onboarding.indiaLocalSetup":
      "સેટઅપ પછી પસંદગીઓમાં કેટલોગ શહેર પસંદ કરો અથવા Android પર ઉપકરણના સ્થાનનો ઉપયોગ કરો.",
    "onboarding.placesSetup": "હવામાન અને મુસાફરીનાં સ્થાનો સેટઅપ પછી પસંદગીઓમાં ઉપલબ્ધ છે.",
    "onboarding.openPreferences": "પસંદગીઓ ખોલો",
    "onboarding.briefOrder": "બ્રીફ ક્રમ",
    "onboarding.countryDefault": "{country} ડિફૉલ્ટ",
    "onboarding.next": "આગળ",
    "onboarding.saved": "તમારું સેટઅપ સેવ થયું",
    "onboarding.createSync": "વેબ અને Android પર આ સેટઅપ રાખવા ખાતું બનાવો.",
    "onboarding.createAccount": "ખાતું બનાવો",
    "onboarding.openBrief": "તમારો બ્રીફ ખોલો",
    "onboarding.createAccountPrompt": "તમારું ખાતું બનાવો",
    "onboarding.openWhenReady": "વૉર્મઅપ પૂરું થાય એટલે તમે એપ ખોલી શકો છો.",
    "onboarding.accountKeepsPrefs": "ખાતું બનાવવાથી તમારી પસંદગીઓ સેવ રહે છે અને સિંક શરૂ થાય છે.",
    "onboarding.openBriefButton": "બ્રીફ ખોલો",
    "layout.audioPlayer": "ઑડિયો પ્લેયર",
    "layout.theme": "થીમ",
    "layout.signOut": "સાઇન આઉટ",
    ...AUTH_COPY.gu,
    ...AUDIO_FEEDBACK_COPY.gu,
    ...CALENDAR_COPY.gu,
    ...CHROME_COPY.gu,
    ...BRIEF_CONTENT_COPY.gu,
    ...BRIEF_CORE_COPY.gu,
    ...BRIEF_TUNE_COPY.gu,
    ...HOME_CAROUSEL_COPY.gu,
    ...HOME_COPY.gu,
    ...LIBRARY_COPY.gu,
    ...MARKETING_MAIN_COPY.gu,
    ...MARKETING_PAGES_COPY.gu,
    ...SETTINGS_COPY.gu,
    ...SETTINGS_PROFILE_COPY.gu,
    ...SETTINGS_SURFACE_COPY.gu,
    ...NATIVE_PARITY_COPY.gu,
    "onboarding.heading": "તમારી પસંદ પ્રમાણે.",
    "onboarding.body": "તમારો દેશ. તમારી ભાષા.\nતમારા માટે દરરોજનો બ્રીફ.",
    "onboarding.edition": "તમારી આવૃત્તિ",
  },
  fr: {
    "common.share": "Partager",
    "common.viewPlans": "Voir les offres",
    "common.tryAgain": "Réessayer",
    "common.refreshing": "Actualisation...",
    "common.remove": "Retirer",
    "common.play": "Lire",
    "common.stop": "Arrêter",
    "common.dismiss": "Fermer",
    "common.loadingAudio": "Audio en chargement",
    "common.nowPlaying": "En lecture",
    "common.audio": "Audio",
    "audio.buffering": "Mise en mémoire tampon",
    "audio.collapse": "Fermer le lecteur agrandi",
    "audio.controls": "Commandes de lecture",
    "audio.download": "Télécharger le MP3",
    "audio.expand": "Ouvrir le lecteur audio complet",
    "audio.forward": "Avancer de 15 secondes",
    "audio.narrator": "Narrateur",
    "audio.narratorFuture": "S’applique à votre prochaine écoute générée",
    "audio.pause": "Mettre l’audio en pause",
    "audio.paused": "En pause",
    "audio.playbackSpeed": "Vitesse de lecture",
    "audio.premiumListening": "Écoute Premium",
    "audio.resume": "Reprendre l’audio",
    "audio.rewind": "Reculer de 15 secondes",
    "audio.seek": "Position audio",
    "audio.stopClose": "Arrêter l’audio et fermer le lecteur",
    "brief.eyebrow": "Brief du jour",
    "brief.goodMorning": "Bonjour",
    "brief.start": "Démarrer le brief",
    "brief.restart": "Recommencer",
    "brief.stopAudio": "Arrêter l'audio",
    "brief.loading": "Chargement...",
    "brief.listenMinutes": "Écoute {minutes} min",
    "brief.addToQueue": "Ajouter à la file",
    "brief.freeAudioNote":
      "Les écoutes gratuites quotidiennes sont incluses. Premium ou essai lève les limites.",
    "brief.loadError": "Impossible de charger votre brief pour le moment.",
    "brief.journey": "Parcours du brief",
    "brief.sectionsMeta": "{count} sections - {depth} - {country}",
    "brief.orderNote": "L'ordre par défaut commence par {order}.",
    "brief.sectionTabs": "Sections du brief",
    "brief.previous": "Précédent",
    "brief.next": "Section suivante",
    "brief.complete": "Terminer le brief",
    "brief.completed": "Brief terminé. Votre dernier parcours a été ajouté à l'historique.",
    "brief.shareIt": "Le partager",
    "brief.tune": "Régler",
    "brief.depth": "Profondeur",
    "brief.depth.focused": "Ciblé",
    "brief.depth.balanced": "Équilibré",
    "brief.depth.deep": "Approfondi",
    "brief.audioLength": "Durée audio",
    "brief.minutes": "{minutes} minutes",
    "brief.includeTasks": "Inclure le contexte des tâches",
    "brief.includeMarkets": "Inclure le pouls des marchés",
    "brief.defaultOrderTitle": "Ordre par défaut {country}",
    "brief.runHistory": "Historique",
    "brief.historyEmpty": "Terminez un brief pour lancer votre historique.",
    "brief.historyLine": "{sections} sections - {minutes} min - {depth}",
    "brief.audioCompanion": "Compagnon audio",
    "brief.downloadCurrent": "Télécharger le MP3",
    "brief.downloadUnavailable":
      "Lancez une écoute générée pour télécharger le MP3 dans ce navigateur.",
    "brief.queueTitle": "À suivre",
    "brief.queueEmpty":
      "Ajoutez une écoute avant une marche, un trajet ou un bloc de concentration.",
    "brief.recentListens": "Écoutes récentes",
    "brief.audioHistoryEmpty": "Les écoutes générées apparaîtront ici au démarrage de la lecture.",
    "brief.queuedStatus": "Ajouté à la file audio.",
    "brief.openSource": "Ouvrir la source",
    "brief.shareText": "Je viens de terminer un Today's Brief de {count} sections.",
    "brief.shareStatusLabel": "Lien du brief",
    "brief.categoryLabel": "Votre brief",
    "brief.fallbackSummary": "Votre brief personnalisé est prêt.",
    "onboarding.title": "Configurer Today's Brief",
    "onboarding.description":
      "Choisissez votre région, votre langue et le style du brief quotidien.",
    "onboarding.eyebrow": "Configuration du premier brief",
    "onboarding.editionBody": "Le pays définit vos titres par défaut et votre liste de marchés.",
    "onboarding.language": "Langue",
    "onboarding.languageBody":
      "Choisissez la langue de départ pour l'app et les actualités. Modifiable plus tard.",
    "onboarding.profile": "Profil du brief",
    "onboarding.profileBody": "Ces choix aident le brief à vous nommer et à régler sa profondeur.",
    "onboarding.displayName": "Nom affiché",
    "onboarding.localCity": "Ville locale",
    "onboarding.optional": "Facultatif",
    "onboarding.briefDepth": "Profondeur du brief",
    "onboarding.preparing": "Préparation...",
    "onboarding.prepare": "Préparer mon brief",
    "onboarding.skip": "Aller à l'app",
    "onboarding.signIn": "J'ai déjà un compte",
    "onboarding.preview": "Aperçu de la configuration",
    "onboarding.previewEdition": "Édition",
    "onboarding.previewPace": "Brief {language} - rythme {depth}",
    "onboarding.firstPaint": "Premier affichage",
    "onboarding.warming": "Contenu en préparation",
    "onboarding.ready": "Prêt",
    "onboarding.warmSources": "Actualités, citation, marchés",
    "onboarding.localIncluded": "Actualités locales de {city} incluses",
    "onboarding.addCity": "Ajoutez une ville pour les titres locaux.",
    "onboarding.indiaLocalSetup":
      "Après la configuration, choisissez une ville du catalogue dans les Préférences ou utilisez la position de l'appareil sur Android.",
    "onboarding.placesSetup":
      "Les lieux de météo et de trajet sont disponibles dans les Préférences après la configuration.",
    "onboarding.openPreferences": "Ouvrir les Préférences",
    "onboarding.briefOrder": "Ordre du brief",
    "onboarding.countryDefault": "Par défaut {country}",
    "onboarding.next": "Suivant",
    "onboarding.saved": "Votre configuration est enregistrée",
    "onboarding.createSync":
      "Créez un compte pour conserver cette configuration sur le web et Android.",
    "onboarding.createAccount": "Créer un compte",
    "onboarding.openBrief": "Ouvrir votre brief",
    "onboarding.createAccountPrompt": "Créer votre compte",
    "onboarding.openWhenReady": "Vous pourrez entrer dans l'app dès la fin de la préparation.",
    "onboarding.accountKeepsPrefs":
      "La création du compte conserve vos préférences et lance la synchronisation.",
    "onboarding.openBriefButton": "Ouvrir le brief",
    "layout.audioPlayer": "Lecteur audio",
    "layout.theme": "Thème",
    "layout.signOut": "Déconnexion",
    ...AUTH_COPY.fr,
    ...AUDIO_FEEDBACK_COPY.fr,
    ...CALENDAR_COPY.fr,
    ...CHROME_COPY.fr,
    ...BRIEF_CONTENT_COPY.fr,
    ...BRIEF_CORE_COPY.fr,
    ...BRIEF_TUNE_COPY.fr,
    ...HOME_CAROUSEL_COPY.fr,
    ...HOME_COPY.fr,
    ...LIBRARY_COPY.fr,
    ...MARKETING_MAIN_COPY.fr,
    ...MARKETING_PAGES_COPY.fr,
    ...SETTINGS_COPY.fr,
    ...SETTINGS_PROFILE_COPY.fr,
    ...SETTINGS_SURFACE_COPY.fr,
    ...NATIVE_PARITY_COPY.fr,
    "onboarding.heading": "À votre image.",
    "onboarding.body": "Votre pays. Votre langue.\nUn Brief quotidien qui vous ressemble.",
    "onboarding.edition": "Votre édition",
  },
  de: {
    "common.share": "Teilen",
    "common.viewPlans": "Tarife ansehen",
    "common.tryAgain": "Erneut versuchen",
    "common.refreshing": "Aktualisieren...",
    "common.remove": "Entfernen",
    "common.play": "Abspielen",
    "common.stop": "Stopp",
    "common.dismiss": "Schließen",
    "common.loadingAudio": "Audio wird geladen",
    "common.nowPlaying": "Jetzt läuft",
    "common.audio": "Audio",
    "audio.buffering": "Wird gepuffert",
    "audio.collapse": "Erweiterten Player schließen",
    "audio.controls": "Wiedergabesteuerung",
    "audio.download": "MP3 herunterladen",
    "audio.expand": "Vollständigen Audioplayer öffnen",
    "audio.forward": "15 Sekunden vorspulen",
    "audio.narrator": "Sprecherstimme",
    "audio.narratorFuture": "Gilt für das nächste generierte Audio",
    "audio.pause": "Audio pausieren",
    "audio.paused": "Pausiert",
    "audio.playbackSpeed": "Wiedergabegeschwindigkeit",
    "audio.premiumListening": "Premium-Audio",
    "audio.resume": "Audio fortsetzen",
    "audio.rewind": "15 Sekunden zurück",
    "audio.seek": "Wiedergabeposition",
    "audio.stopClose": "Audio stoppen und Player schließen",
    "brief.eyebrow": "Heutiges Briefing",
    "brief.goodMorning": "Guten Morgen",
    "brief.start": "Briefing starten",
    "brief.restart": "Neu starten",
    "brief.stopAudio": "Audio stoppen",
    "brief.loading": "Lädt...",
    "brief.listenMinutes": "{minutes} Min. hören",
    "brief.addToQueue": "Zur Warteschlange",
    "brief.freeAudioNote":
      "Kostenlose tägliche Hörer sind enthalten. Premium oder Testphase hebt Limits an.",
    "brief.loadError": "Dein Briefing konnte gerade nicht geladen werden.",
    "brief.journey": "Briefing-Ablauf",
    "brief.sectionsMeta": "{count} Abschnitte - {depth} - {country}",
    "brief.orderNote": "Die Standardreihenfolge beginnt mit {order}.",
    "brief.sectionTabs": "Briefing-Abschnitte",
    "brief.previous": "Zurück",
    "brief.next": "Nächster Abschnitt",
    "brief.complete": "Briefing abschließen",
    "brief.completed": "Briefing abgeschlossen. Dein letzter Lauf wurde gespeichert.",
    "brief.shareIt": "Teilen",
    "brief.tune": "Anpassen",
    "brief.depth": "Tiefe",
    "brief.depth.focused": "Fokussiert",
    "brief.depth.balanced": "Ausgewogen",
    "brief.depth.deep": "Tief",
    "brief.audioLength": "Audiolänge",
    "brief.minutes": "{minutes} Minuten",
    "brief.includeTasks": "Aufgabenkontext einbeziehen",
    "brief.includeMarkets": "Marktpuls einbeziehen",
    "brief.defaultOrderTitle": "{country} Standardreihenfolge",
    "brief.runHistory": "Verlauf",
    "brief.historyEmpty": "Schließe ein Briefing ab, um deinen Verlauf zu starten.",
    "brief.historyLine": "{sections} Abschnitte - {minutes} Min. - {depth}",
    "brief.audioCompanion": "Audio-Begleiter",
    "brief.downloadCurrent": "Aktuelle MP3 laden",
    "brief.downloadUnavailable":
      "Starte ein generiertes Audio, um die MP3 in diesem Browser zu laden.",
    "brief.queueTitle": "Als Nächstes",
    "brief.queueEmpty":
      "Lege ein Audio für Spaziergang, Fahrt oder Fokuszeit in die Warteschlange.",
    "brief.recentListens": "Zuletzt gehört",
    "brief.audioHistoryEmpty": "Generierte Audios erscheinen hier nach Start der Wiedergabe.",
    "brief.queuedStatus": "Zur Audiowarteschlange hinzugefügt.",
    "brief.openSource": "Quelle öffnen",
    "brief.shareText": "Ich habe gerade ein Today's Brief mit {count} Abschnitten abgeschlossen.",
    "brief.shareStatusLabel": "Briefing-Link",
    "brief.categoryLabel": "Dein Briefing",
    "brief.fallbackSummary": "Dein personalisiertes Briefing ist bereit.",
    "onboarding.title": "Today's Brief einrichten",
    "onboarding.description": "Wähle Region, Sprache und Stil deines täglichen Briefings.",
    "onboarding.eyebrow": "Erstes Briefing einrichten",
    "onboarding.editionBody": "Das Land bestimmt Standardnachrichten und Markt-Watchlist.",
    "onboarding.language": "Sprache",
    "onboarding.languageBody": "Wähle die Startsprache für App und Nachrichten. Später änderbar.",
    "onboarding.profile": "Briefing-Profil",
    "onboarding.profileBody": "Diese Angaben helfen beim Namen und bei der passenden Tiefe.",
    "onboarding.displayName": "Anzeigename",
    "onboarding.localCity": "Lokale Stadt",
    "onboarding.optional": "Optional",
    "onboarding.briefDepth": "Briefing-Tiefe",
    "onboarding.preparing": "Wird vorbereitet...",
    "onboarding.prepare": "Mein Briefing vorbereiten",
    "onboarding.skip": "Zur App",
    "onboarding.signIn": "Ich habe schon ein Konto",
    "onboarding.preview": "Einrichtungs-Vorschau",
    "onboarding.previewEdition": "Ausgabe",
    "onboarding.previewPace": "{language}-Briefing - {depth} Tempo",
    "onboarding.firstPaint": "Erster Inhalt",
    "onboarding.warming": "Inhalte werden vorbereitet",
    "onboarding.ready": "Bereit",
    "onboarding.warmSources": "Nachrichten, Zitat, Märkte",
    "onboarding.localIncluded": "Lokale Nachrichten aus {city} enthalten",
    "onboarding.addCity": "Füge eine Stadt für lokale Schlagzeilen hinzu.",
    "onboarding.indiaLocalSetup":
      "Wähle nach der Einrichtung unter Einstellungen eine Katalogstadt aus oder verwende unter Android den Gerätestandort.",
    "onboarding.placesSetup":
      "Orte für Wetter und Pendelstrecke sind nach der Einrichtung unter Einstellungen verfügbar.",
    "onboarding.openPreferences": "Einstellungen öffnen",
    "onboarding.briefOrder": "Briefing-Reihenfolge",
    "onboarding.countryDefault": "{country} Standard",
    "onboarding.next": "Weiter",
    "onboarding.saved": "Deine Einrichtung ist gespeichert",
    "onboarding.createSync":
      "Erstelle ein Konto, um diese Einrichtung auf Web und Android zu behalten.",
    "onboarding.createAccount": "Konto erstellen",
    "onboarding.openBrief": "Briefing öffnen",
    "onboarding.createAccountPrompt": "Konto erstellen",
    "onboarding.openWhenReady": "Du kannst die App öffnen, sobald die Vorbereitung fertig ist.",
    "onboarding.accountKeepsPrefs":
      "Ein Konto speichert deine Präferenzen und startet die Synchronisierung.",
    "onboarding.openBriefButton": "Briefing öffnen",
    "layout.audioPlayer": "Audioplayer",
    "layout.theme": "Design",
    "layout.signOut": "Abmelden",
    ...AUTH_COPY.de,
    ...AUDIO_FEEDBACK_COPY.de,
    ...CALENDAR_COPY.de,
    ...CHROME_COPY.de,
    ...BRIEF_CONTENT_COPY.de,
    ...BRIEF_CORE_COPY.de,
    ...BRIEF_TUNE_COPY.de,
    ...HOME_CAROUSEL_COPY.de,
    ...HOME_COPY.de,
    ...LIBRARY_COPY.de,
    ...MARKETING_MAIN_COPY.de,
    ...MARKETING_PAGES_COPY.de,
    ...SETTINGS_COPY.de,
    ...SETTINGS_PROFILE_COPY.de,
    ...SETTINGS_SURFACE_COPY.de,
    ...NATIVE_PARITY_COPY.de,
    "onboarding.heading": "Ganz nach Ihrem Geschmack.",
    "onboarding.body": "Ihr Land. Ihre Sprache.\nEin täglicher Brief, der zu Ihnen passt.",
    "onboarding.edition": "Deine Ausgabe",
  },
  ja: {
    "common.share": "共有",
    "common.viewPlans": "プランを見る",
    "common.tryAgain": "もう一度試す",
    "common.refreshing": "更新中...",
    "common.remove": "削除",
    "common.play": "再生",
    "common.stop": "停止",
    "common.dismiss": "閉じる",
    "common.loadingAudio": "音声を読み込み中",
    "common.nowPlaying": "再生中",
    "common.audio": "音声",
    "audio.buffering": "バッファリング中",
    "audio.collapse": "拡大プレーヤーを閉じる",
    "audio.controls": "再生コントロール",
    "audio.download": "MP3をダウンロード",
    "audio.expand": "フル音声プレーヤーを開く",
    "audio.forward": "15秒進む",
    "audio.narrator": "ナレーター",
    "audio.narratorFuture": "次に生成する音声に適用されます",
    "audio.pause": "音声を一時停止",
    "audio.paused": "一時停止中",
    "audio.playbackSpeed": "再生速度",
    "audio.premiumListening": "プレミアムリスニング",
    "audio.resume": "音声を再開",
    "audio.rewind": "15秒戻る",
    "audio.seek": "再生位置",
    "audio.stopClose": "音声を停止してプレーヤーを閉じる",
    "brief.eyebrow": "今日のブリーフ",
    "brief.goodMorning": "おはようございます",
    "brief.start": "ブリーフ開始",
    "brief.restart": "やり直す",
    "brief.stopAudio": "音声を停止",
    "brief.loading": "読み込み中...",
    "brief.listenMinutes": "{minutes}分で聴く",
    "brief.addToQueue": "キューに追加",
    "brief.freeAudioNote":
      "無料の毎日リスニングが含まれます。プレミアムまたはトライアルで制限が広がります。",
    "brief.loadError": "現在ブリーフを読み込めません。",
    "brief.journey": "ブリーフの流れ",
    "brief.sectionsMeta": "{count} セクション - {depth} - {country}",
    "brief.orderNote": "既定の順序は {order} から始まります。",
    "brief.sectionTabs": "ブリーフのセクション",
    "brief.previous": "前へ",
    "brief.next": "次のセクション",
    "brief.complete": "ブリーフを完了",
    "brief.completed": "ブリーフが完了しました。最新の実行が履歴に追加されました。",
    "brief.shareIt": "共有",
    "brief.tune": "調整",
    "brief.depth": "深さ",
    "brief.depth.focused": "集中",
    "brief.depth.balanced": "標準",
    "brief.depth.deep": "詳細",
    "brief.audioLength": "音声の長さ",
    "brief.minutes": "{minutes}分",
    "brief.includeTasks": "タスク文脈を含める",
    "brief.includeMarkets": "市場パルスを含める",
    "brief.defaultOrderTitle": "{country} 既定の順序",
    "brief.runHistory": "実行履歴",
    "brief.historyEmpty": "ブリーフを完了すると履歴が始まります。",
    "brief.historyLine": "{sections} セクション - {minutes}分 - {depth}",
    "brief.audioCompanion": "音声コンパニオン",
    "brief.downloadCurrent": "現在のMP3をダウンロード",
    "brief.downloadUnavailable": "このブラウザでMP3を保存するには、生成音声を開始してください。",
    "brief.queueTitle": "次に再生",
    "brief.queueEmpty": "散歩、移動、集中時間の前に音声をキューに追加できます。",
    "brief.recentListens": "最近のリスニング",
    "brief.audioHistoryEmpty": "生成音声は再生開始後にここへ表示されます。",
    "brief.queuedStatus": "音声キューに追加しました。",
    "brief.openSource": "ソースを開く",
    "brief.shareText": "{count}セクションのToday's Briefを完了しました。",
    "brief.shareStatusLabel": "ブリーフリンク",
    "brief.categoryLabel": "あなたのブリーフ",
    "brief.fallbackSummary": "パーソナライズされたブリーフの準備ができました。",
    "onboarding.title": "Today's Briefを設定",
    "onboarding.description": "地域、言語、毎日のブリーフのスタイルを選びます。",
    "onboarding.eyebrow": "初回ブリーフ設定",
    "onboarding.editionBody": "国により既定の見出しと市場ウォッチリストが決まります。",
    "onboarding.language": "言語",
    "onboarding.languageBody": "最初のアプリ/ニュース言語を選びます。後で変更できます。",
    "onboarding.profile": "ブリーフプロフィール",
    "onboarding.profileBody": "名前の呼び方と開始時の深さを調整します。",
    "onboarding.displayName": "表示名",
    "onboarding.localCity": "ローカル都市",
    "onboarding.optional": "任意",
    "onboarding.briefDepth": "ブリーフの深さ",
    "onboarding.preparing": "準備中...",
    "onboarding.prepare": "ブリーフを準備",
    "onboarding.skip": "アプリへ進む",
    "onboarding.signIn": "すでにアカウントがあります",
    "onboarding.preview": "設定プレビュー",
    "onboarding.previewEdition": "エディション",
    "onboarding.previewPace": "{language}ブリーフ - {depth}ペース",
    "onboarding.firstPaint": "最初の表示",
    "onboarding.warming": "コンテンツ準備中",
    "onboarding.ready": "準備完了",
    "onboarding.warmSources": "ニュース、引用、市場",
    "onboarding.localIncluded": "{city}のローカルニュースを含みます",
    "onboarding.addCity": "ローカル見出し用に都市を追加してください。",
    "onboarding.indiaLocalSetup":
      "セットアップ後に設定でカタログの都市を選ぶか、Androidで端末の位置情報を使用してください。",
    "onboarding.placesSetup": "天気と通勤の場所は、セットアップ後に設定で指定できます。",
    "onboarding.openPreferences": "設定を開く",
    "onboarding.briefOrder": "ブリーフ順序",
    "onboarding.countryDefault": "{country}既定",
    "onboarding.next": "次",
    "onboarding.saved": "設定を保存しました",
    "onboarding.createSync": "WebとAndroidでこの設定を保つにはアカウントを作成してください。",
    "onboarding.createAccount": "アカウント作成",
    "onboarding.openBrief": "ブリーフを開く",
    "onboarding.createAccountPrompt": "アカウントを作成",
    "onboarding.openWhenReady": "準備が終わるとすぐにアプリを開けます。",
    "onboarding.accountKeepsPrefs": "アカウント作成で設定が保存され、同期が始まります。",
    "onboarding.openBriefButton": "ブリーフを開く",
    "layout.audioPlayer": "音声プレーヤー",
    "layout.theme": "テーマ",
    "layout.signOut": "サインアウト",
    ...AUTH_COPY.ja,
    ...AUDIO_FEEDBACK_COPY.ja,
    ...CALENDAR_COPY.ja,
    ...CHROME_COPY.ja,
    ...BRIEF_CONTENT_COPY.ja,
    ...BRIEF_CORE_COPY.ja,
    ...BRIEF_TUNE_COPY.ja,
    ...HOME_CAROUSEL_COPY.ja,
    ...HOME_COPY.ja,
    ...LIBRARY_COPY.ja,
    ...MARKETING_MAIN_COPY.ja,
    ...MARKETING_PAGES_COPY.ja,
    ...SETTINGS_COPY.ja,
    ...SETTINGS_PROFILE_COPY.ja,
    ...SETTINGS_SURFACE_COPY.ja,
    ...NATIVE_PARITY_COPY.ja,
    "onboarding.heading": "あなたに合わせて。",
    "onboarding.body": "国と言語を選んで、\n自分に合う毎日のBriefを。",
    "onboarding.edition": "あなたのエディション",
  },
  bn: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.bn,
    ...FOUNDATION_COPY.bn,
    ...ONBOARDING_COPY.bn,
    ...MARKETING_SHELL_COPY.bn,
    ...SETTINGS_FOUNDATION_COPY.bn,
    ...PREAUTH_AUTH_CHROME_COPY.bn,
    ...MARKETING_MAIN_COPY.bn,
    ...NATIVE_PARITY_COPY.bn,
  },
  te: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.te,
    ...FOUNDATION_COPY.te,
    ...ONBOARDING_COPY.te,
    ...MARKETING_SHELL_COPY.te,
    ...SETTINGS_FOUNDATION_COPY.te,
    ...PREAUTH_AUTH_CHROME_COPY.te,
    ...MARKETING_MAIN_COPY.te,
    ...NATIVE_PARITY_COPY.te,
  },
  mr: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.mr,
    ...FOUNDATION_COPY.mr,
    ...ONBOARDING_COPY.mr,
    ...MARKETING_SHELL_COPY.mr,
    ...SETTINGS_FOUNDATION_COPY.mr,
    ...PREAUTH_AUTH_CHROME_COPY.mr,
    ...MARKETING_MAIN_COPY.mr,
    ...NATIVE_PARITY_COPY.mr,
  },
  ta: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.ta,
    ...FOUNDATION_COPY.ta,
    ...ONBOARDING_COPY.ta,
    ...MARKETING_SHELL_COPY.ta,
    ...SETTINGS_FOUNDATION_COPY.ta,
    ...PREAUTH_AUTH_CHROME_COPY.ta,
    ...MARKETING_MAIN_COPY.ta,
    ...NATIVE_PARITY_COPY.ta,
  },
  ur: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.ur,
    ...FOUNDATION_COPY.ur,
    ...ONBOARDING_COPY.ur,
    ...MARKETING_SHELL_COPY.ur,
    ...SETTINGS_FOUNDATION_COPY.ur,
    ...PREAUTH_AUTH_CHROME_COPY.ur,
    ...MARKETING_MAIN_COPY.ur,
    ...NATIVE_PARITY_COPY.ur,
  },
  kn: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.kn,
    ...FOUNDATION_COPY.kn,
    ...ONBOARDING_COPY.kn,
    ...MARKETING_SHELL_COPY.kn,
    ...SETTINGS_FOUNDATION_COPY.kn,
    ...PREAUTH_AUTH_CHROME_COPY.kn,
    ...MARKETING_MAIN_COPY.kn,
    ...NATIVE_PARITY_COPY.kn,
  },
  or: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.or,
    ...FOUNDATION_COPY.or,
    ...ONBOARDING_COPY.or,
    ...MARKETING_SHELL_COPY.or,
    ...SETTINGS_FOUNDATION_COPY.or,
    ...PREAUTH_AUTH_CHROME_COPY.or,
    ...MARKETING_MAIN_COPY.or,
    ...NATIVE_PARITY_COPY.or,
  },
  ml: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.ml,
    ...FOUNDATION_COPY.ml,
    ...ONBOARDING_COPY.ml,
    ...MARKETING_SHELL_COPY.ml,
    ...SETTINGS_FOUNDATION_COPY.ml,
    ...PREAUTH_AUTH_CHROME_COPY.ml,
    ...MARKETING_MAIN_COPY.ml,
    ...NATIVE_PARITY_COPY.ml,
  },
  pa: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.pa,
    ...FOUNDATION_COPY.pa,
    ...ONBOARDING_COPY.pa,
    ...MARKETING_SHELL_COPY.pa,
    ...SETTINGS_FOUNDATION_COPY.pa,
    ...PREAUTH_AUTH_CHROME_COPY.pa,
    ...MARKETING_MAIN_COPY.pa,
    ...NATIVE_PARITY_COPY.pa,
  },
  pnb: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.pnb,
    ...FOUNDATION_COPY.pnb,
    ...ONBOARDING_COPY.pnb,
    ...MARKETING_SHELL_COPY.pnb,
    ...SETTINGS_FOUNDATION_COPY.pnb,
    ...PREAUTH_AUTH_CHROME_COPY.pnb,
    ...MARKETING_MAIN_COPY.pnb,
    ...NATIVE_PARITY_COPY.pnb,
  },
  as: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.as,
    ...FOUNDATION_COPY.as,
    ...ONBOARDING_COPY.as,
    ...MARKETING_SHELL_COPY.as,
    ...SETTINGS_FOUNDATION_COPY.as,
    ...PREAUTH_AUTH_CHROME_COPY.as,
    ...MARKETING_MAIN_COPY.as,
    ...NATIVE_PARITY_COPY.as,
  },
  es: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.es,
    ...FOUNDATION_COPY.es,
    ...ONBOARDING_COPY.es,
    ...MARKETING_SHELL_COPY.es,
    ...SETTINGS_FOUNDATION_COPY.es,
    ...PREAUTH_AUTH_CHROME_COPY.es,
    ...MARKETING_MAIN_COPY.es,
    ...NATIVE_PARITY_COPY.es,
  },
  zh: {
    ...ENGLISH_COPY_DICTIONARY,
    ...AUDIO_FEEDBACK_COPY.zh,
    ...FOUNDATION_COPY.zh,
    ...ONBOARDING_COPY.zh,
    ...MARKETING_SHELL_COPY.zh,
    ...SETTINGS_FOUNDATION_COPY.zh,
    ...PREAUTH_AUTH_CHROME_COPY.zh,
    ...MARKETING_MAIN_COPY.zh,
    ...NATIVE_PARITY_COPY.zh,
  },
};

export function normalizePublicWebLang(lang: string | undefined | null): string {
  const code = restoredProductLanguage(lang) || "en";
  return COPY_BY_LANG[code] ? code : "en";
}

export function publicWebCopy(
  key: PublicWebCopyKey,
  lang: string | undefined | null,
  vars: CopyVars = {},
): string {
  const code = normalizePublicWebLang(lang);
  const template = COPY_BY_LANG[code]?.[key] || COPY_BY_LANG.en[key] || key;
  return template.replace(/\{([a-zA-Z0-9_]+)\}/g, (_, name: string) => {
    const value = vars[name];
    return value == null ? "" : String(value);
  });
}

export function publicWebCopyForLang(lang: string | undefined | null) {
  return (key: PublicWebCopyKey, vars?: CopyVars) => publicWebCopy(key, lang, vars);
}

export function publicWebDepthLabel(
  depth: "focused" | "balanced" | "deep" | string,
  lang: string | undefined | null,
): string {
  if (depth === "focused" || depth === "balanced" || depth === "deep") {
    return publicWebCopy(`brief.depth.${depth}`, lang);
  }
  return String(depth || "");
}
